module.exports = __webpack_public_path__ + "img/contact.64fb8a6c.svg";